import { useEffect, useState, useRef, useCallback } from 'react'
import { OrderProgressEntity } from 'orders/domain/entities/order.entity'
import { OrderDetailHttpRepository } from 'orders/infrastructure/repositories/OrderDetailHttpRepository'

const repo = new OrderDetailHttpRepository()

interface UseOrderProgressResult {
    progress: OrderProgressEntity | null
    loading: boolean
    error: string | null
    refetch: (containerCode?: string) => void
}

export function useOrderProgress(orderId: number): UseOrderProgressResult {
    const [progress, setProgress] = useState<OrderProgressEntity | null>(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const cancelledRef = useRef(false)

    const fetchProgress = useCallback(async (containerCode?: string) => {
        if (!orderId) return
        cancelledRef.current = false
        setLoading(true)
        setError(null)
        try {
            const data = await repo.getOrderProgress(orderId, containerCode)
            if (!cancelledRef.current) setProgress(data)
        } catch {
            if (!cancelledRef.current) setError('No se pudo cargar el progreso de la orden.')
        } finally {
            if (!cancelledRef.current) setLoading(false)
        }
    }, [orderId])

    useEffect(() => {
        fetchProgress()
        return () => { cancelledRef.current = true }
    }, [fetchProgress])

    return { progress, loading, error, refetch: fetchProgress }
}
